import React, { useCallback, useEffect, useState } from 'react';
import { isSafari } from 'react-device-detect';
import { Platform, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import DataTrackerChart from '../../components/charts/DataTrackerChart';
import Colors from '../../constants/Colors';
import {
  disableOrientationLock,
  enablePortraitOrientationLock
} from '../../tools/DeviceHelper';
import Spacer from '../../components/Spacer';
import { useFocusEffect } from '@react-navigation/core';
import * as ScreenOrientation from 'expo-screen-orientation';

const sampleData = [
  [
    { x: 1, y: 7 },
    { x: 2, y: 7.9 },
    { x: 3, y: 7.9 },
    { x: 4, y: 8.1 },
    { x: 5, y: 9.5 },
    { x: 6, y: 9.8 },
    { x: 7, y: 10 },
    { x: 8, y: 10.2 },
    { x: 9, y: 10.4 },
    { x: 10, y: 10.6 },
    { x: 11, y: 10.6 },
    { x: 12, y: 10.4 },
    { x: 13, y: 9.4 },
    { x: 14, y: 8.5 },
    { x: 15, y: 8 },
    { x: 16, y: 7.6 }
  ],
  [
    { x: 1, y: 5 },
    { x: 2, y: 5 },
    { x: 3, y: 5 },
    { x: 4, y: 5 },
    { x: 5, y: 5 },
    { x: 6, y: 5 },
    { x: 7, y: 5 },
    { x: 7, y: 6 },
    { x: 7, y: 7 },
    { x: 7, y: 8 },
    { x: 7, y: 9 },
    { x: 7.01, y: 10 },
    { x: 7.05, y: 10 },
    { x: 7.99, y: 10 },
    { x: 7.1, y: 10 },
    { x: 7.2, y: 10 },
    { x: 7.3, y: 10 },
    { x: 7.4, y: 10 },
    { x: 7.5, y: 10 },
    { x: 8, y: 10 },
    { x: 9, y: 10 },
    { x: 10, y: 10 },
    { x: 11, y: 10 },
    { x: 12, y: 10 },
    { x: 13, y: 10 },
    { x: 14, y: 10 },
    { x: 15, y: 10 },
    { x: 16, y: 10, label: 'Dose (mg)' }
  ]
];

const StyledView = styled.ScrollView<{
  isDesktop: boolean;
}>`
  height: 100%;
  width: 100%;
  background: ${Colors.background};
  padding: ${p =>
    Platform.OS === 'web'
      ? p.isDesktop
        ? '64px 100px 0px 100px'
        : '64px 37px 0px 37px'
      : '64px 37px 0px 37px'};
  align-self: center;
  ${isSafari ? 'width: 85%' : ''}
`;

const DataTrackerChartScreen: React.FC = () => {
  useFocusEffect(
    useCallback(() => {
      disableOrientationLock();
      return () => {
        setTimeout(() => enablePortraitOrientationLock(), 500);
      };
    }, [])
  );

  const [orientation, setOrientation] = useState(
    ScreenOrientation.Orientation.PORTRAIT_UP
  );

  useEffect(() => {
    ScreenOrientation.getOrientationAsync().then(info => {
      setOrientation(info);
    });

    const subscription = ScreenOrientation.addOrientationChangeListener(evt => {
      setOrientation(evt.orientationInfo.orientation);
    });

    return () => {
      ScreenOrientation.removeOrientationChangeListener(subscription);
    };
  }, []);

  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;

  return (
    <StyledView isDesktop={isDesktop}>
      <DataTrackerChart
        yAxisLeftLabel='SLEEP DURATION (HRS)'
        yAxisRightLabel='DOSE (MG)'
        data={sampleData}
        xAxisMaxValueLabel={26}
        yAxisMaxValueLabel={13}
        fullWidth={orientation >= 2}
        displayAllDayLabels={orientation >= 2}
      />
      <Spacer size={10} />
    </StyledView>
  );
};

export default DataTrackerChartScreen;
